var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('apollo-query',_vm._g(_vm._b({ref:"apolloQuery",attrs:{"query":_vm.query,"deep":_vm.deep,"tag":null},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var ref_result = ref.result;
var loading = ref_result.loading;
var data = ref_result.data;
var isLoading = ref.isLoading;
return [(loading || isLoading)?_c('div',[(_vm.showLoader)?_c('div',{staticClass:"text-center"},[_c('x-circular-progress')],1):_vm._e()]):(data)?[_vm._t("default",null,{"result":data})]:_vm._e()]}}])},'apollo-query',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }